import React, { useState } from 'react'
import left from './Images/Left.png'
import right from './Images/Right.png'
import sticks from './Images/Sticks.png'
import stars from './Images/stars.png'
import './wrap.css'
import { Link, useNavigate } from 'react-router-dom'
import { Box, Button, Modal, Typography } from '@mui/material'
const WrapUp = () => {
    const navigate = useNavigate()
    const [show,setShow] = useState(false)
    const [open,setOpen] = useState(true)

    setTimeout(()=>{
        setShow(true)
    },3000)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        height:300,
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        outline:'none',
        borderRadius:'7px',
        p: 4,
        display:'flex',
        flexDirection:'column',
        alignItems:'center'
      };

      const count = localStorage.getItem("rate_count");

    //   const rateus = process.env.REAT_APP_WEBSTORE_LINK
      const rateus = process.env.REACT_APP_WEBSTORE_LINK
      
      const dashboard = process.env.REACT_APP_DASHBOARD
      const bug = process.env.REACT_APP_REPORT_AND_BUG
      const reports = process.env.REACT_APP_DASHBOARD_REPORTS

  return (
    <div style={{height:'100%',width:'100%', display:'flex', justifyContent:'center',alignItems:'center'}}>
    {/* Modal */}
    <Modal
    open={open && count==='10'}
    onClose={()=>setOpen(false)}
    aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
    >
        <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{display:"flex",flexDirection:'column',alignItems:'center'}}>
        <img src={stars} height='150px' width='150px' alt="" />
      Rate us on WebStore
    </Typography>
    {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
      Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
    </Typography> */}
    <Link to={rateus} target='_blank' onClick={()=>setOpen(false)}><Button variant="outlined">Rate Us</Button></Link>
  </Box>
    </Modal>


    <img src={left} alt="" height='120px' width='120px' className='position absolute left-0 top-0'/>
    
    <img src={right} alt=""   width='230px' className='position absolute bottom-0 right-0' />
    <div className='center' style={{display:'flex',flexDirection:'column',alignItems:'center'}} >
    {show && <i class="fas fa-times-circle cancle" style={{color:'grey',cursor:'pointer'}} onClick={()=>navigate('/')}></i>}

        <div className='greet'>
            <img src={sticks} alt="" className='sticks-top' />
            <h1>Thank You</h1>
            <img src={sticks} alt="" className='sticks-bottom' />
        </div>
        <div className='bottom-container' style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
            <h1>That's a wrap</h1>
            <p>Your Summary is now available.</p>
            <Link to={reports} target='_blank'>
            <button><i class="fas fa-file-download download" style={{marginRight:'5px'}}></i><p>View Summary</p></button>
            </Link>
            <Link to={bug} target='_blank' style={{color:'#FFFFFF'}}>Report a bug</Link>
        </div>
    </div>
    </div>
  )
}

export default WrapUp